export enum GroupFilter {
  My = 'my',
  Team = 'team',
  All = 'all',
}
